import React from 'react';
import { connect } from 'react-redux';
import RoleMenuModal from '../../components/MenuItems/Admin/RoleMenuModal';
import SVGComponent from '../../components/SVG/SVGComponent';
import { ROLE_STATUS, SVG_ICONS } from '../../constants';
import { getRoles } from '../../selectors/admin';
import { getTimezone } from '../../selectors/common';
import { getDateTime } from '../../utils/common';
import { aDisableEnableRole } from '../../reducers';

const mapToProps = (state) => ({
  getTimezone: getTimezone(state),
  roles: getRoles(state),
});

const actionsToProps = (dispatch) => ({
  changeRoleStatus: (payload) => dispatch(aDisableEnableRole(payload)),
});

const RoleSettingsRows = (props) => (
  props.roles.map((role) => {
    const openClass = role.roleId === props.moreModalRoleId ? ' open active ' : '';
    return (
      <tr key={role.roleId} className={`table-style__row ${openClass}`}>
        <td>{role.roleId}</td>
        <td>{role.name}</td>
        <td>{role.description}</td>
        <td>{getDateTime(role.insertionDate, props.getTimezone)}</td>
        <td>{role.insertionUser}</td>
        <td>{ROLE_STATUS[role.status]}</td>
        {(props.hasPermissionTo.enableDisable
          || props.hasPermissionTo.edit
          || props.hasPermissionTo.remove)
          && (
            <td className="table-style__icon" onClick={props.openMoreModal.bind(this, role)}>
              <SVGComponent
                className="icon-xs"
                src={`${SVG_ICONS.utility}#dots`}
              />
              <RoleMenuModal
                role={role}
                closeMoreModal={props.closeMoreModal}
                refreshGrid={props.refreshGrid}
                openEditRole={props.openEditRole}
                removeRole={props.removeRole}
                changeRoleStatus={props.changeRoleStatus}
                hasPermissionTo={props.hasPermissionTo}
                openConfirmationModal={props.openConfirmationModal}
              />
            </td>
          )}
      </tr>
    );
  })
);
export default connect(mapToProps, actionsToProps)(RoleSettingsRows);
